import React, { useEffect, useState, SyntheticEvent } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Tooltip from '@mui/material/Tooltip'
import CardHeader from '@mui/material/CardHeader'
import Typography from '@mui/material/Typography'
import axios from 'axios'
import {
    Autocomplete,
    Avatar,
    CardActions,
    CardContent,
    Divider,
    Fab,
    FormHelperText,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tab,
    Button,
    TextField
} from '@mui/material'

import Icon from '../../../components/icon';
import { darken, lighten, styled } from '@mui/material/styles'
import { ButtonProps, FormControl } from '@mui/material'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import moment from 'moment'
import 'moment/locale/id'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import DialogContentText from '@mui/material/DialogContentText'

import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import Checkbox from '@mui/material/Checkbox'

import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import apiUrl from '../../../configs/constant';

import Swal from 'sweetalert2'
import { useToast } from '../../../components/ToastProvider'
import { useNavigate } from 'react-router-dom'

const btnExcel = {
    color: '#fff',
    backgroundColor: '#10ac84',
    m: 3,

    '&:hover': {
        backgroundColor: '#10ac84'
    }
}

const defaultSteps = [
    { transaksi: '1. Setup Periode', status: null, message: '', sp: null },
    { transaksi: '2. Rekalkulasi Pembelian', status: null, message: '', sp: null },
    { transaksi: '3. Rekalkulasi Hasil Produksi', status: null, message: '', sp: null },
    { transaksi: '4. Rekalkulasi Hasil RFS', status: null, message: '', sp: null },
    { transaksi: '5. Rekalkulasi BHP', status: null, message: '', sp: null },
    { transaksi: '6. Rekalkulasi Usage Umum', status: null, message: '', sp: null },
    { transaksi: '7. Rekalkulasi Usage Produksi', status: null, message: '', sp: null }
]

const Index = () => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const showToast = useToast();

    const navigate = useNavigate();

    // ===== State =====
    const [listData, setListData] = useState<any[]>([])
    const [listPeriodeAkhir, setListPeriodeAkhir] = useState<any[]>([])
    const [valPeriodeAkhir, setValPeriodeAkhir] = useState<any>(null)

    const [listPeriodeAwal, setListPeriodeAwal] = useState<any[]>([])
    const [valPeriodeAwal, setValPeriodeAwal] = useState<any>(null)

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [listDetailLog, setListDetailLog] = useState<any>([])
    const [listDetail, setListDetail] = useState<any>([])

    const [cardStates, setCardStates] = useState<Record<number, { loading: boolean; arrItems: any[] }>>({})


    const convertDate = (pdate: Date) => {
        const yyyy = pdate.getFullYear()
        let mm = pdate.getMonth() + 1 // Months start at 0!
        let dd = pdate.getDate()

        let sdd: string = dd.toString()
        let smm: string = mm.toString()

        if (dd < 10) sdd = '0' + dd
        if (mm < 10) smm = '0' + mm

        const formatted = sdd + '-' + smm + '-' + yyyy

        return formatted
    }

    useEffect(() => {
        getListPeriode()
    }, [])

    useEffect(() => {
        if (!listData || listData.length === 0) {
            setCardStates({})
            return
        }

        const init: Record<number, { loading: boolean; arrItems: any[] }> = {}
        listData.forEach(d => {
            init[d.id] = {
                loading: false,
                arrItems: listDetail.map((s: any) => ({ ...s }))
            }
        })
        setCardStates(init)

    }, [listData])

    const getDataFilter = (periodeAwal: any, periodeAkhir: any) => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/laporan-keuangan/master-rekalkulasi-persediaan'
        axios
            .get(url, {
                params: { tgl_awal: periodeAwal, tgl_akhir: periodeAkhir },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.close()
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const getListPeriode = () => {
        const url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-periode'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListPeriodeAwal(data)
                    setListPeriodeAkhir(data)
                    if (data && data.length > 0) {
                        setValPeriodeAwal(data[0])
                        setValPeriodeAkhir(data[0])
                        getDataFilter(data[0].id, data[0].id)
                    }
                    getDetailSetting()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const getDetailSetting = () => {
        const url = apiUrl.apiUrl + '/acc/posting-jurnal/detail-setting'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data

                    const newData = data.map((item: any) => ({
                        ...item,
                        message: '',
                        status: null
                    }))

                    setListDetail(newData)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const getDetailSettingLog = (periodeAwal: any, periodeAkhir: any) => {
        const url = apiUrl.apiUrl + '/acc/posting-jurnal/detail-setting-log'
        axios
            .get(url, {
                params: {
                    tgl_awal: periodeAwal,
                    tgl_akhir: periodeAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDetailLog(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(err => {
                Swal.fire({ title: 'Error', text: err.message || 'Terjadi kesalahan', icon: 'error' })
            })
    }

    const handleChangeAutocompleteAwal = (event: SyntheticEvent, newValue: any | null) => {
        if (newValue != null) {
            setValPeriodeAwal(newValue)
        } else {
            setValPeriodeAwal(null)
        }
    }

    const handleChangeAutocompleteAkhir = (event: SyntheticEvent, newValue: any | null) => {
        if (newValue != null) {
            setValPeriodeAkhir(newValue)
        } else {
            setValPeriodeAkhir(null)
        }
    }

    const handlePostingBulk = async (periodeId: number) => {
        const card = cardStates[periodeId]
        if (!card) return

        setCardStates(prev => ({
            ...prev,
            [periodeId]: {
                ...prev[periodeId],
                loading: true,
                arrItems: prev[periodeId].arrItems.map((a) => ({
                    ...a,
                    status: null,
                    message: ''
                }))
            }
        }))

        const periode = listData.find(p => p.id === periodeId)
        if (!periode) return

        for (let i = 0; i < card.arrItems.length; i++) {
            const step = card.arrItems[i]

            setCardStates(prev => {
                const current = prev[periodeId]
                const nextItems = [...current.arrItems]
                nextItems[i] = {
                    ...nextItems[i],
                    status: undefined,
                    message: 'Memproses...'
                }
                return {
                    ...prev,
                    [periodeId]: { ...current, arrItems: nextItems }
                }
            })

            try {
                const url = `${apiUrl.apiUrl}/acc/posting-jurnal/posting`
                const res = await axios.post(
                    url,
                    {
                        transaksi: step.transaksi,
                        sp: step.sp,
                        tgl_awal: moment(periode.tgl_awal).format('YYYY-MM-DD'),
                        tgl_akhir: moment(periode.tgl_akhir).format('YYYY-MM-DD')
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                )

                const isSuccess = !!res.data.success

                setCardStates(prev => {
                    const current = prev[periodeId]
                    const nextItems = [...current.arrItems]
                    nextItems[i] = {
                        ...nextItems[i],
                        status: isSuccess,
                        message: res.data.message || ''
                    }
                    return {
                        ...prev,
                        [periodeId]: { ...current, arrItems: nextItems }
                    }
                })
            } catch (err: any) {
                const msg = err?.response?.data?.message || err.message || 'Error saat koneksi'
                setCardStates(prev => {
                    const current = prev[periodeId]
                    const nextItems = [...current.arrItems]
                    nextItems[i] = {
                        ...nextItems[i],
                        status: false,
                        message: msg
                    }
                    return {
                        ...prev,
                        [periodeId]: { ...current, arrItems: nextItems }
                    }
                })

                // If it's a 504 Gateway Timeout, log the error but continue to next step
                if (err?.response?.status === 504) {
                    // small delay before continuing to reduce immediate retries
                    await new Promise(r => setTimeout(r, 200))
                    continue
                }

                // For other errors, stop the bulk process
                break
            }

            await new Promise(r => setTimeout(r, 200))
        }

        setCardStates(prev => ({
            ...prev,
            [periodeId]: { ...prev[periodeId], loading: false }
        }))
    }


    const handlePosting = async (item: any, stepIndex: any, step: any) => {
        const card = cardStates[item.id]
        if (!card) return

        // Set status loading untuk step tertentu
        setCardStates(prev => {
            const next = { ...prev }
            const card = next[item.id]
            const arrItems = [...card.arrItems]
            arrItems[stepIndex] = { ...arrItems[stepIndex], status: undefined, message: 'Memproses...' }
            next[item.id] = { ...card, arrItems }
            return next
        })

        try {
            const url = `${apiUrl.apiUrl}/acc/posting-jurnal/posting`
            const res = await axios.post(
                url,
                {
                    transaksi: step.transaksi,
                    sp: step.sp,
                    tgl_awal: moment(item.tgl_awal).format('YYYY-MM-DD'),
                    tgl_akhir: moment(item.tgl_akhir).format('YYYY-MM-DD'),
                },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )

            const isSuccess = !!res.data.success

            setCardStates(prev => {
                const next = { ...prev }
                const card = next[item.id]
                const arrItems = [...card.arrItems]
                arrItems[stepIndex] = {
                    ...arrItems[stepIndex],
                    status: isSuccess,
                    message: res.data.message || ''
                }
                next[item.id] = { ...card, arrItems }
                return next
            })
        } catch (err: any) {
            setCardStates(prev => {
                const next = { ...prev }
                const card = next[item.id]
                const arrItems = [...card.arrItems]
                arrItems[stepIndex] = {
                    ...arrItems[stepIndex],
                    status: false,
                    message: err?.response?.data?.message || err.message || 'Error saat koneksi'
                }
                next[item.id] = { ...card, arrItems }
                return next
            })
        }
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='POSTING JURNAL' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                startIcon={<Icon icon="mdi:history" />}
                                onClick={() => {
                                    getDetailSettingLog(valPeriodeAwal?.id, valPeriodeAkhir?.id)
                                    setOpenDialog(true)
                                }}
                            >
                                LOG POSTING
                            </Button>
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    value={valPeriodeAwal}
                                    options={listPeriodeAwal}
                                    id="Periode Awal"
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeAutocompleteAwal}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.transaksi}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.transaksi}
                                    renderInput={params => <TextField {...params} label="Periode Awal" />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    value={valPeriodeAkhir}
                                    options={listPeriodeAkhir}
                                    id="Periode Akhir"
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onChange={handleChangeAutocompleteAkhir}
                                    renderOption={(props, option) => {
                                        return (
                                            <li {...props} key={option.id}>
                                                {option.transaksi}
                                            </li>
                                        )
                                    }}
                                    getOptionLabel={option => option.transaksi}
                                    renderInput={params => <TextField {...params} label="Periode Akhir" />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Button
                                    sx={{ marginTop: 2, marginLeft: 3, marginRight: 3 }}
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Icon icon="mdi:magnify" />}
                                    onClick={() => {
                                        getDataFilter(valPeriodeAwal?.id, valPeriodeAkhir?.id)
                                        getDetailSetting()
                                    }}
                                >
                                    Cari Data
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid container spacing={4} sx={{ my: 6 }}>
                            {listData.map((item, index) => {
                                const card = cardStates[item.id] || { loading: false, arrItems: listDetail.map((s: any) => ({ ...s })) }
                                return (
                                    <Grid item xs={12} sm={4} key={index}>
                                        <Card sx={{ width: 400 }} variant="outlined">
                                            <CardContent>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2 }}>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Periode
                                                        </Typography>
                                                        <Typography variant="body1">: {item.keterangan}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Tanggal Awal
                                                        </Typography>
                                                        <Typography variant="body1">: {moment(item.tgl_awal).format('LL')}</Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex' }}>
                                                        <Typography sx={{ width: 130, fontWeight: 500 }} variant="body1">
                                                            Tanggal Akhir
                                                        </Typography>
                                                        <Typography variant="body1">: {moment(item.tgl_akhir).format('LL')}</Typography>
                                                    </Box>
                                                </Box>

                                                <Divider sx={{ mb: 2 }} />

                                                <List dense disablePadding>
                                                    {card.arrItems.map((step, idx) => (
                                                        <ListItem
                                                            key={idx}
                                                            sx={{
                                                                py: 0.5,
                                                                px: 0,
                                                                borderBottom: idx < card.arrItems.length - 1 ? '1px solid #eee' : 'none'
                                                            }}
                                                            secondaryAction={
                                                                <ListItemIcon sx={{ minWidth: 32 }}>
                                                                    {(() => {
                                                                        if (step.status === true) {
                                                                            return (
                                                                                <IconButton>
                                                                                    <Icon icon="mdi:check-circle" color="green" fontSize={22} />
                                                                                </IconButton>
                                                                            )
                                                                        } else if (step.status === false) {
                                                                            return (
                                                                                <Tooltip title={step.message || ''}>
                                                                                    <IconButton onClick={() => handlePosting(item, idx, step)}>
                                                                                        <Icon icon="mdi:close-circle" color="red" fontSize={22} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )
                                                                        } else if (step.status === null) {
                                                                            return (
                                                                                <IconButton onClick={() => handlePosting(item, idx, step)}>
                                                                                    <Icon icon="mdi:sync-circle" color="#999" fontSize={22} />
                                                                                </IconButton>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return (
                                                                                <Icon icon="mdi:clock-outline" color="#999" fontSize={22} />
                                                                            )
                                                                        }
                                                                    })()}
                                                                </ListItemIcon>
                                                            }
                                                        >
                                                            <ListItemText primary={step.transaksi} />
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </CardContent>
                                            {listDetail.length > 0 ? (
                                                <CardActions sx={{ justifyContent: 'center' }}>
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        color="primary"
                                                        disabled={card.loading}
                                                        onClick={() => handlePostingBulk(item.id)}
                                                        startIcon={<Icon icon={card.loading ? 'mdi:loading' : 'mdi:check-circle'} className={card.loading ? 'spin' : ''} />}
                                                    >
                                                        {card.loading ? 'PROSES...' : 'POSTING'}
                                                    </Button>
                                                </CardActions>
                                            ) : (
                                                ''
                                            )}
                                        </Card>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </CardContent>
                </div>
            </Grid>

            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title' textAlign='center'>
                    Log Posting Jurnal
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                value={valPeriodeAwal}
                                options={listPeriodeAwal}
                                id="Periode Awal"
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={handleChangeAutocompleteAwal}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.id}>
                                            {option.periode}
                                        </li>
                                    )
                                }}
                                getOptionLabel={option => option.periode}
                                renderInput={params => <TextField {...params} label="Periode Awal" />}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                value={valPeriodeAkhir}
                                options={listPeriodeAkhir}
                                id="Periode Akhir"
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                onChange={handleChangeAutocompleteAkhir}
                                renderOption={(props, option) => {
                                    return (
                                        <li {...props} key={option.id}>
                                            {option.periode}
                                        </li>
                                    )
                                }}
                                getOptionLabel={option => option.periode}
                                renderInput={params => <TextField {...params} label="Periode Akhir" />}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Button
                                sx={{ marginTop: 2, marginLeft: 3, marginRight: 3 }}
                                variant="contained"
                                color="primary"
                                startIcon={<Icon icon="mdi:magnify" />}
                                onClick={() => getDetailSettingLog(valPeriodeAwal?.id, valPeriodeAkhir?.id)}
                            >
                                Cari Data
                            </Button>
                        </Grid>
                    </Grid>
                    <MsiDatagrid array={listDetailLog} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default Index